<template>
    <div class="group-toplist" v-if="groups.length > 0">
        <h2>{{ groups.length === 1 ? 'Min gruppe' : 'Mine grupper' }} - {{ groupName }}</h2>
        <div class="unit-switch">
            <span class="unit-switch__label" :class="{ 'unit-switch__label--active': selectedUnit === 'kg' }">Kg</span>
            <button
                type="button"
                class="unit-switch__track"
                :class="{ 'unit-switch__track--liters': selectedUnit === 'liters' }"
                role="switch"
                :aria-checked="selectedUnit === 'liters'"
                aria-label="Bytt mellom kg og liter"
                @click="selectedUnit = selectedUnit === 'kg' ? 'liters' : 'kg'"
            >
                <span class="unit-switch__thumb"></span>
            </button>
            <span class="unit-switch__label" :class="{ 'unit-switch__label--active': selectedUnit === 'liters' }">Liter</span>
        </div>
        <div class="group-toplist__table-wrapper">
            <table class="group-toplist__table">
                <thead>
                    <tr>
                        <th></th>
                        <th v-for="item of sortedItems" :key="item.id">
                            <img
                                v-if="item.illustration_src"
                                :src="item.illustration_src"
                                :alt="item.illustration_alt || item.name"
                                class="group-toplist__type-icon"
                            >
                            <div class="group-toplist__type-name">{{ item.name }}</div>
                        </th>
                        <th class="group-toplist__total-header">Totalt</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="group of groups" :key="group.id">
                        <td class="group-toplist__group-name">{{ group.name }}</td>
                        <td v-for="item of sortedItems" :key="item.id" class="group-toplist__amount">
                            {{ formatAmount(group, item.id) }}
                        </td>
                        <td class="group-toplist__amount group-toplist__amount--total">
                            {{ formatTotal(group) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['items', 'groups', 'groupName'],
        data() {
            return {
                selectedUnit: 'kg',
            };
        },
        computed: {
            sortedItems() {
                return [...this.items].sort((a, b) => a.name.localeCompare(b.name, 'no'));
            },
        },
        methods: {
            formatAmount(group, itemId) {
                const amount = group.items[itemId] ? group.items[itemId][this.selectedUnit] : 0;

                return `${amount.toFixed(1)} ${this.selectedUnit === 'liters' ? 'L' : 'kg'}`;
            },
            formatTotal(group) {
                const amount = group.total[this.selectedUnit];

                return `${amount.toFixed(1)} ${this.selectedUnit === 'liters' ? 'L' : 'kg'}`;
            },
        },
    }
</script>
